// Renders the first numeric column of the first row as a big number.
// Falls back to whatever the first column contains if no numeric
// value is found. Suitable for COUNT(*) / SUM(...) measures.

interface Props {
  rows: Record<string, unknown>[];
}

const fmt = new Intl.NumberFormat('en-AU');

export function Kpi({ rows }: Props) {
  const row = rows[0];
  const [, value] = Object.entries(row).find(([, v]) => typeof v === 'number') ??
    Object.entries(row)[0] ?? ['value', ''];

  const display = typeof value === 'number' ? fmt.format(value) : String(value ?? '');

  return (
    <div className="kpi-value">
      {display}
      <style>{`.kpi-value { font-size: 32px; font-weight: 600; color: var(--ac-blue-dark); font-variant-numeric: tabular-nums; }`}</style>
    </div>
  );
}
